module.exports = __webpack_public_path__ + "static/img/case1.93bc08e9.svg";